/**
 * RNR's Label, in the design system's caption treatment: uppercase, tracked, muted.
 *
 * The label is always present. A placeholder is not a label, because it disappears exactly when it
 * is needed.
 */
import { cn } from '@/lib/utils';
import * as LabelPrimitive from '@rn-primitives/label';
import { Platform } from 'react-native';

function Label({
  className,
  onPress,
  onLongPress,
  onPressIn,
  onPressOut,
  disabled,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Text>) {
  return (
    <LabelPrimitive.Root
      className={cn(
        'flex select-none flex-row items-center gap-2',
        Platform.select({ web: 'cursor-default peer-disabled:cursor-not-allowed peer-disabled:opacity-50' }),
        disabled && 'opacity-50',
      )}
      onPress={onPress}
      onLongPress={onLongPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      disabled={disabled}>
      <LabelPrimitive.Text className={cn('text-muted-foreground text-caption uppercase', className)} {...props} />
    </LabelPrimitive.Root>
  );
}

export { Label };
